import React from 'react';
import { AppBar, Toolbar, Button, Container, Box } from '@mui/material';
import { Link } from 'react-router-dom'; // If you are using React Router for navigation
import logo from '../assets/images/adoop.png';


const Navbar = () => {

function logout(){
  localStorage.removeItem('accessToken');
  window.location.href = '/';
}

  return (
    <AppBar position="sticky" style={{background:"white",color:"black"}}>
      <Toolbar>
        <Container>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {/* Logo or title */}
           <img src={logo} alt='' width={100}/>
            
            {/* Navbar Links/Buttons */}
            <Box>
              {/* <Button color="inherit" component={Link} to="/">
                Home
              </Button> */}
              <Button color="inherit" component={Link} to="/admin">
                Dashboard
              </Button>
              <Button color="inherit" component={Link} to="/shopkeeper">
                Shopkeeper_List
              </Button>
              <Button color="inherit" component={Link} to="/catalogs">
                Catalogs_List
              </Button>
              <Button color="inherit" component={Link} to="/spam">
                Spam_List
              </Button>
              <Button color="inherit" component={Link} to="/spam" onClick={logout}>
                Logout
              </Button>
              {/* <Button color="inherit" component={Link} to="/userlist">
                Users_List
              </Button> */}
            </Box>
          </Box>
        </Container>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
